import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { Box, Container, Typography } from '@mui/material';
import { env } from '@/config/env';

const SPEC_URL = `${env.tokenApiUrl}/token/docs/spec`;

export function ApiDocs(): React.ReactElement {
  return (
    <>
      <Box sx={{ bgcolor: 'background.default' }}>
        <Container maxWidth="xl" sx={{ pt: 4, pb: 3 }}>
          <Typography variant="h1" gutterBottom>
            API Documentation
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Interactive reference for the Sophia Partner APIs. Authenticate requests using an API
            key generated in the API Keys tab.
          </Typography>
        </Container>
      </Box>
      <Box sx={{ bgcolor: 'background.paper', flex: 1 }}>
        <SwaggerUI url={SPEC_URL} docExpansion="list" defaultModelsExpandDepth={-1} />
      </Box>
    </>
  );
}
